import { Badge } from "react-bootstrap";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/FedericoSn.jpg";
import HollowPicture from "./imgs/hollow.png";
import SlayPicture from "./imgs/slay.png";
import WarframePicture from "./imgs/war.jpg";
import RoketPicture from "./imgs/roket.webp";
import InfoCard from "../../Componentes/CardInfoFede/InfoCard";
import ItemCard from "../../Componentes/CardInfoFede//ItemCard";
import calcularEdad from "Hooks/calcularEdad";

const FedericoSn = () => {
  return (
    <div className='container-fluid'>
      <div className='h3 text-center'>
        <div className=' col-2 mx-auto'>
          <img
            width={100}
            height={100}
            alt='foto de perfil'
            className=' rounded-circle'
            src={ProfilePicture}
          />
        </div>

        <label className='mr-3'>Federico Martin Estañoli</label>
        <label className='text-secondary'> Jr. Mobile Developer</label>
      </div>
      <div className='row p-2'>
        <InfoCard titulo='Sobre mi'>
          <ItemCard>
            Soy de la provincia de Córdoba, ciudad de Río Tercero.
          </ItemCard>
          <ItemCard>
            Nací el 29/01/1997, tengo
            <span title='edad'> {calcularEdad(new Date("1997-01-29"))} </span>
            años.
          </ItemCard>
          <ItemCard>
            Me falta entregar la tesis para egresarme de Técnico Superior en
            Desarrollo de Software.
          </ItemCard>
          <ItemCard>
            Soy Técnico Quimico egresado del secundario. (cuando todavía no
            sabés que hacen en el futuro jaja)
          </ItemCard>
        </InfoCard>
        <InfoCard titulo='Música'>
          <ItemCard>
            Tengo gustos variados, pero en este momento estoy escuchando mucha
            musica y bandas sonoras de videojuegos
          </ItemCard>
        </InfoCard>
        <InfoCard titulo='Videojuegos'>
          <ItemCard>
            Principalmente juego juegos independientes o de empresas pequeñas:
          </ItemCard>
          <ItemCard
            link='https://store.steampowered.com/app/367520/Hollow_Knight/'
            img={HollowPicture}>
            Hollow knight
          </ItemCard>
          <ItemCard
            link='https://store.steampowered.com/app/646570/Slay_the_Spire/'
            img={SlayPicture}>
            Slay the Spire
          </ItemCard>
          <ItemCard>Y otros no tan independientes</ItemCard>
          <ItemCard link='https://www.warframe.com/' img={WarframePicture}>
            Warframe
          </ItemCard>
          <ItemCard
            link='https://www.rocketleague.com/es-es/'
            img={RoketPicture}>
            Roket League
          </ItemCard>
        </InfoCard>
      </div>
      <div>
        <InfoCard titulo='Tecnologías que manejo'>
          <div className='p-2'>
            <Badge title='badge' className='mx-1' variant='primary'>
              HTML 5
            </Badge>
            <Badge title='badge' className='mx-1' variant='primary'>
              JavaScript
            </Badge>
            <Badge title='badge' className='mx-1' variant='warning'>
              React-native
            </Badge>
            <Badge title='badge' className='mx-1' variant='primary'>
              PHP
            </Badge>
          </div>
        </InfoCard>
      </div>
    </div>
  );
};

export default new Content({
  Component: FedericoSn,
  title: "Federico Estañoli",
  route: "federico-sn",
  tags: ["React Native", "HTML", "CSS", "JavaScript", "Junior"]
});
